import { useState } from 'react'
import clsx from 'clsx'

/**
 * Reden-dialoog voor "Klant heeft afgezien". De aanvraag wordt wél als Lead
 * geregistreerd (funnel-data, pariteit met booking-flow) maar direct met de
 * verloren-status — er gaat geen offerte-mail uit.
 */
export function AfgezienDialog({
  isOpen,
  isSubmitting,
  onConfirm,
  onClose,
}: {
  isOpen: boolean
  isSubmitting: boolean
  onConfirm: (reason: string) => void
  onClose: () => void
}) {
  const [reason, setReason] = useState('')
  const valid = reason.trim().length >= 3

  if (!isOpen) return null

  return (
    <>
      <div className="fixed inset-0 bg-black/30 z-40" onClick={isSubmitting ? undefined : onClose} />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-md p-5 space-y-4 pointer-events-auto">
          <div>
            <h3 className="text-base font-semibold text-slate-900">Klant heeft afgezien</h3>
            <p className="text-sm text-slate-600 mt-1">
              De aanvraag wordt geregistreerd met de reden — de klant ontvangt géén offerte-mail.
            </p>
          </div>
          <div>
            <label className="text-xs font-medium text-slate-600 mb-1.5 block">Reden *</label>
            <textarea
              autoFocus
              rows={3}
              placeholder="Bijv. te duur, gaat eerst nadenken, elders geboekt..."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="w-full px-3 py-2 border border-slate-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none"
            />
          </div>
          <div className="flex gap-3">
            <button
              onClick={onClose}
              disabled={isSubmitting}
              className="flex-1 px-4 py-2.5 text-sm font-medium text-slate-600 border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors"
            >
              Annuleren
            </button>
            <button
              onClick={() => valid && onConfirm(reason.trim())}
              disabled={!valid || isSubmitting}
              className={clsx(
                'flex-1 px-4 py-2.5 text-sm font-medium rounded-lg transition-colors',
                valid && !isSubmitting
                  ? 'bg-red-600 text-white hover:bg-red-700'
                  : 'bg-slate-200 text-slate-400 cursor-not-allowed'
              )}
            >
              {isSubmitting ? 'Bezig...' : 'Registreren'}
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
